export enum TUTORIAL {
	longTapToSubmit = 0,
	first = 1,
	vocabulary = 2,

}
